import get from 'lodash/get.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoRadio',
  inject: {
    $form: {
      default: ''
    },
    $radioGroup: {
      default: ''
    }
  },
  props: {
    value: {
      type: null,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    selectedDetails: {
      type: [Boolean, Object],
      default: false
    }
  },
  data() {
    return {
      focus: false
    };
  },
  computed: {
    showSelectedDetails() {
      if (!this.$slots.selectedDetails && !this.selectedDetails) {
        return false;
      }
      return this.isChecked;
    },
    isRadioGroupChild() {
      return Boolean(this.$radioGroup);
    },
    model: {
      get() {
        return this.isRadioGroupChild ? this.$radioGroup.value : this.value;
      },
      set(val) {
        if (this.isRadioGroupChild) {
          this.$radioGroup.$emit('input', val);
        } else {
          this.$emit('input', val);
        }
      }
    },
    isDisabled() {
      const isFormDisabled = get(this, '$form.disabled');
      const isGroupDisabled = get(this, '$radioGroup.disabled');
      return isGroupDisabled || this.disabled || isFormDisabled;
    },
    isChecked() {
      return this.model === this.value;
    },
    inputName() {
      const radioGroupName = get(this, '$radioGroup.groupName', null);
      return this.name || radioGroupName;
    }
  },
  methods: {
    handleChange: _async(function () {
      const _this = this;
      return _await(_this.$nextTick(), function () {
        _this.$emit('change', _this.value);
        if (_this.isRadioGroupChild) {
          _this.$radioGroup.$emit('change', _this.value);
        }
      });
    })
  }
};

export { script as default };
//# sourceMappingURL=pendo-radio.vue2.js.map
